import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

const DataCorrectionModal = ({
  showModal,
  setShowModal,
  userName,
  password,
  setPassword,
  setIsAuthorized,
}) => {
  const [showError, setShowError] = useState(false);
  return (
    <Dialog open={showModal} onClose={() => setShowModal(false)}>
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Electronic Signature
        </Typography>
      </div>
      <DialogContent>
        <TextField
          size="small"
          fullWidth
          disabled={true}
          value={userName || ""}
        />
        <TextField
          size="small"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          style={{ marginTop: "20px" }}
        />
        {showError && (
          <div
            className="error-container"
            style={{
              fontSize: "12px",
            }}
          >
            Please Enter Password
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <button
          className="create-btn"
          style={{ minWidth: "120px", marginRight: "10px" }}
          onClick={() => {
            if (password.trim().length !== 0) {
              setShowModal(false);
              setIsAuthorized(true);
            } else {
              setShowError(true);
            }
          }}
        >
          Submit
        </button>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DataCorrectionModal;
